import React from "react";

import PageStructure from "../components/ui/PageStructure";
import { FAVOURITE_GOAL } from "../utils/constants";

// component for favourite goals page
const Favourite: React.FC = () => {
  return <PageStructure title="favourite goals" filter={FAVOURITE_GOAL} />;
};

export default Favourite;
